import useSWR from "swr";
import { useApi } from "../api";
import { CustomError } from "../errors";
import { SCREW_CONNECTOR_SETTINGS_URL } from "./screwConnectorUrl";
import { Settings } from "./types/settings";

/**
 * The whole catalog the calculation's page works on, in one call, in the user's language (as the Deck Designer's
 * settings). One request instead of one per list: a burst of them, each looking the user up on the IAM, could be
 * refused and show up as an expired session.
 */
export const useScrewConnectorSettings = () => {
  const api = useApi();

  return useSWR<Settings, CustomError, string>(SCREW_CONNECTOR_SETTINGS_URL, (requestUrl: string) =>
    api.get<Settings>({ url: requestUrl }),
  );
};
